<template>
  <section class="section">
    <h1>{{ $t('orderCreate.heading') }}</h1>
    <div v-if="Array.isArray(users) && Array.isArray(clients)">
      <NewOrder
        :user="user"
        :users="users"
        :clients="clients"
      />
    </div>
  </section>
</template>

<style scoped>
  .section {
    margin: 100px 0;
  }
</style>

<script>
  import NewOrder from '../order/NewOrder.vue';

  export default {
    components: {
      NewOrder
    },
    props: [ 'user' ],
    data() {
      return {
        users: null,
        clients: null
      };
    },
    beforeCreate: async function() {
      const data = await Promise.all([
        fetch('/api/user'),
        fetch('/api/client')
      ]);

      const json = await Promise.all(data.map(response => response.json()));

      if (['abg_manager', 'abg_user'].includes(this.user.role)) {
        this.users = json[0].filter(user => !['abg_manager', 'abg_user'].includes(user.role));
        this.clients = json[1].filter(client => client.name !== 'ABG');
      } else {
        this.users = json[0].filter(user => user.id === this.user.id);
        this.clients = json[1].filter(client => client.id === this.user.client_id);
      }
    }
  }
</script>
